<aside
  class="bn-pp-sidebar"
  [class.bn-pp-sidebar--is-open]="isMobileMenuOpened()">
  <header class="bn-pp-sidebar__header">
    <a
      class="bn-pp-sidebar__logo"
      routerLink="/">
      <img
        alt="bunny.net"
        class="bn-pp-sidebar__logo-img"
        src="assets/web-ui/images/logo-bunny-dark.svg" />
    </a>

    <div class="bn-pp-sidebar__user-wrap">
      <button
        class="bn-pp-sidebar__user"
        data-e2e="PartnerPortalSidebarUserMenuButton"
        type="button"
        (click)="toggleUserMenu()">
        <img
          class="bn-pp-sidebar__avatar"
          ngxGravatar
          [email]="userEmail() ?? ''"
          [size]="24" />
        <fa-icon
          class="bn-pp-sidebar__user-caret"
          icon="chevron-down" />
      </button>

      @if (isUserMenuOpen()) {
        <div
          class="bn-pp-sidebar__user-backdrop"
          data-e2e="PartnerPortalSidebarUserMenuBackdrop"
          (click)="toggleUserMenu()"></div>
        <div class="bn-dropdown bn-pp-sidebar__user-menu">
          @if (userEmail()) {
            <div class="bn-dropdown__header">{{ userEmail() }}</div>
            <hr class="bn-dropdown__divider" />
          }
          <div class="bn-dropdown__item">
            <button
              class="bn-dropdown__item-link bn-pp-sidebar__logout"
              data-e2e="PartnerPortalSidebarLogoutButton"
              type="button"
              (click)="onLogout()">
              <fa-icon icon="right-from-bracket" />
              <span>Log Out</span>
            </button>
          </div>
        </div>
      }
    </div>

    <button
      aria-label="Close menu"
      class="bn-pp-sidebar__close"
      data-e2e="PartnerPortalSidebarCloseMobileMenuButton"
      type="button"
      (click)="onCloseMobileMenu()">
      <fa-icon
        class="bn-pp-sidebar__close-icon"
        icon="xmark" />
    </button>
  </header>

  <div class="bn-pp-sidebar__mobile-user">
    <img
      class="bn-pp-sidebar__mobile-avatar"
      ngxGravatar
      [email]="userEmail() ?? ''"
      [size]="30" />
    <span class="bn-pp-sidebar__mobile-email">{{ userEmail() }}</span>
  </div>

  <bn-layout-main-menu
    [childRoutes]="childRoutes"
    [menuConfig]="menuConfig" />

  <button
    class="bn-pp-sidebar__mobile-logout"
    data-e2e="PartnerPortalSidebarLogoutButtonMobile"
    type="button"
    (click)="onLogout()">
    Log Out
  </button>

  <div class="bn-pp-sidebar__cta">
    <button
      class="bn-pp-sidebar__add-customer"
      data-e2e="PartnerPortalSidebarAddCustomerButton"
      type="button"
      (click)="onAddCustomer()">
      <fa-icon icon="plus" />
      <span>Add Customer</span>
    </button>
  </div>
</aside>
